var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.333c.104 0 .21.037.29.111l4.923 4.572c.16.149.16.39 0 .539a.433.433 0 01-.58 0L8 6.253l-4.633 4.302a.433.433 0 01-.58 0 .362.362 0 010-.539L7.71 5.444a.425.425 0 01.29-.11z",
    fill: "#282828"
  })));
}
export default SvgArrowUp;